const suppressedSignals = new WeakSet<AbortSignal>();

/**
 * Prevents the legacy default error modal for errors associated with this request.
 *
 * The signal is scoped to one React Query request, so callers can opt out without
 * changing shared endpoint fetchers or affecting unrelated requests.
 */
export const suppressFetchErrorModalForSignal = (signal: AbortSignal | undefined) => {
  if (signal != null) {
    suppressedSignals.add(signal);
  }
};

export const isFetchErrorModalSuppressedForSignal = (signal: AbortSignal | undefined) =>
  signal != null && suppressedSignals.has(signal);
